import { render, staticRenderFns } from "./ChapterPopup.vue?vue&type=template&id=29935565&scoped=true"
import script from "./ChapterPopup.vue?vue&type=script&lang=js"
export * from "./ChapterPopup.vue?vue&type=script&lang=js"
import style0 from "./ChapterPopup.vue?vue&type=style&index=0&id=29935565&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29935565",
  null
  
)

export default component.exports